import {HttpClient} from '@angular/common/http';
import {ToastService} from '../../toast-service';
import {Injectable} from "@angular/core";
import {BatchUpdateRequest} from "../../../model/api/batch-update-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../model/api/api-validation";
import {Trade} from "../../../model/clearing/trade";
import {CrystalclearSupportBackUrl} from "../../config/crystalclear-support-back-url";
import {CommonCrudService} from "../../common/common-crud.service";

@Injectable({
  providedIn: 'root'
})
export class SupportTradeService extends CommonCrudService<Trade> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearSupportBackUrl.GET_SUPPORT_TRADE_LIST,
      CrystalclearSupportBackUrl.SAVE_SUPPORT_TRADE,
      CrystalclearSupportBackUrl.DELETE_SUPPORT_TRADE);
  }

  public saveBatch(request: BatchUpdateRequest<Trade>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSupportBackUrl.SAVE_BATCH_SUPPORT_TRADE, request);
  }

}
